module.exports = __webpack_public_path__ + "img/activities-6.8bacf51d.jpg";